const MoreIconRound: React.VFC = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="more-icon-round"
  >
    <circle cx="16" cy="16" r="16" fill="#F9F9F9" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14 16C14 14.8954 14.8954 14 16 14C17.1046 14 18 14.8954 18 16C18 17.1046 17.1046 18 16 18C14.8954 18 14 17.1046 14 16Z"
      fill="#161015"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21 16C21 14.8954 21.8954 14 23 14C24.1046 14 25 14.8954 25 16C25 17.1046 24.1046 18 23 18C21.8954 18 21 17.1046 21 16Z"
      fill="#161015"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 16C7 14.8954 7.89543 14 9 14C10.1046 14 11 14.8954 11 16C11 17.1046 10.1046 18 9 18C7.89543 18 7 17.1046 7 16Z"
      fill="#161015"
    />
  </svg>
)

export default MoreIconRound
